import {NotFoundRoute} from '@tanstack/react-router';
import {NotFoundErrorScreen} from 'shared';

import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

import {Route} from './routes/__root';

export const notFoundRoute = new NotFoundRoute({
  getParentRoute: () => Route,

  component: NotFoundErrorScreen,
  beforeLoad: () => makeDocumentTitle('Not Found'),
});
